import { useCopy } from '@/hooks/use-copy';
export default {
  mounted(el, binding) {
    const eventType = binding?.arg || 'click';
    el.addEventListener(eventType, async () => {
      const text = binding.value;
      await useCopy(text);
    });
  }
};
